module.exports = __webpack_public_path__ + "img/register-account.fc532554.svg";